/* tslint:disable */
/* eslint-disable */
/**
 * BackendFramework
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @interface WritingSystem
 */
export interface WritingSystem {
  /**
   *
   * @type {string}
   * @memberof WritingSystem
   */
  bcp47: string;
  /**
   *
   * @type {string}
   * @memberof WritingSystem
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof WritingSystem
   */
  font: string;
  /**
   *
   * @type {boolean}
   * @memberof WritingSystem
   */
  rtl?: boolean | null;
}
